import { useContext, useState, useEffect, useRef, forwardRef } from "react";
import formatCurrency from "../../func/currency_formatter";
import { TemplateContext } from "../../layout";
import DoubleTagIcon from "/fallbacks/DoubleTagIcon.svg";
import { decode } from "html-entities";
import ProductSelectorButton from "../ProductSelectorButton.jsx";

const ProductBundleItem = forwardRef((props, ref) => {
  const { product, handleChange, active, index } = props;
  const [templateContext] = useContext(TemplateContext);
  const [render, setRender] = useState();
  const [fadeIn, setFadeIn] = useState();
  const variantsRef = useRef();
  const withLabel = product.best_seller;
  const bestValue = product.best_value;
  const [priceObject, setPriceObject] = useState({
    number: 0,
    cents: 0,
    symbol: 0,
    symbolLeft: true,
  });

  useEffect(() => {
    if (active) {
      setRender(true);
      setTimeout(() => {
        setFadeIn(active);
      }, 300);
    } else {
      setFadeIn(false);
      setTimeout(() => {
        setRender(false);
      }, 150);
    }
  }, [active]);

  const productsContent = window?.post_template.checkout_v4_products;
  const cardBackground = productsContent.checkout_v4_products_CardBackground;
  const cardBackgroundSelected = productsContent.checkout_v4_products_selectedCardBackground;
  const cardBorder = productsContent.checkout_v4_products_borderColor;
  const cardBorderSelected = productsContent.checkout_v4_products_borderColorSelected;
  const textPrimary = productsContent.checkout_v4_products_textPrimary;
  const textSecondary = productsContent.checkout_v4_products_textSecondary;
  const outlineBorder = productsContent.checkout_v4_products_imageWrap;
  const showBadges = productsContent.checkout_v4_products_badgeShow;
  const textBestValue = productsContent?.checkout_v4_products_bestValue;
  const textBestSeller = productsContent?.checkout_v4_products_bestSeller;
  const textBadge = productsContent?.checkout_v4_products_badgeTextColor;
  const cardButtonColor = window?.post_template?.checkout_v4_products?.checkout_v4_products_checkButtonCcColor;

  document.documentElement.style.setProperty("--checkbutton-cc-color", cardButtonColor);
  document.documentElement.style.setProperty("--card-background-active", cardBackgroundSelected);
  document.documentElement.style.setProperty("--card-border-active", cardBorderSelected);
  document.documentElement.style.setProperty("--card-border", cardBorder);
  document.documentElement.style.setProperty("--card-background", cardBackground);
  document.documentElement.style.setProperty("--card-text-primary", textPrimary);
  document.documentElement.style.setProperty("--card-text-secondary", textSecondary);
  document.documentElement.style.setProperty("--best-value-text", textBestValue);
  document.documentElement.style.setProperty("--best-seller-text", textBestSeller);
  document.documentElement.style.setProperty("--text-badge", textBadge);

  function removeCurrencySymbol(currencyString) {
    const currencyRegex = /(?:^\D+)|(?:\D+$)/;
    const currencySymbol = currencyString.match(currencyRegex)[0];
    const value = currencyString.replace(currencyRegex, "");
    return { currencySymbol, value };
  }

  function identifyCurrencySymbol(array) {
    const currencyRegex = /(?:^\D+)|(?:\D+$)/;
    const firstItemHasSymbol = currencyRegex.test(array[0].trim());

    if (firstItemHasSymbol) {
      const splitedFirstNumber = removeCurrencySymbol(array[0].trim());

      console.log(array);
      setPriceObject({
        symbolLeft: true,
        number:
          window.productData.currency_code === "ZAR" ? splitedFirstNumber.value : Number(splitedFirstNumber.value),
        cents: Number(array[1]) !== 0 ? array[1] : "00",
        symbol: splitedFirstNumber.currencySymbol,
      });
      return;
    } else {
      const splitedSecondNumber = removeCurrencySymbol(array[1]);
      setPriceObject({
        symbolLeft: false,
        number: array[0],
        cents: splitedSecondNumber.value,
        symbol: splitedSecondNumber.currencySymbol.trim(),
      });
      return;
    }
  }

  useEffect(() => {
    const formattedCurrency = product?.formatted_price
      ? product?.formatted_price
      : formatCurrency(Number(product?.price));
    let splitedValue;

    if (formattedCurrency.includes("R ")) {
      const parts = product.price.split(".");
      if (parts[0].length >= 3) {
        parts[0] = Number(parts[0]).toLocaleString();
      }
      splitedValue = ["R" + parts[0], parts[1]];
    } else {
      if (formattedCurrency.includes(",")) {
        splitedValue = formattedCurrency.split(",");
      } else {
        splitedValue = formattedCurrency.split(".");
      }
    }

    identifyCurrencySymbol(splitedValue);
  }, []);

  const fallbackImages = window.post_template.checkout_v4_products.checkout_v4_product_images;

  const matchingImage =
    fallbackImages && fallbackImages.find((obj) => obj.product_amount === product.amount)?.product_image;

  const image = matchingImage ? matchingImage : product.image.url;

  let price;
  let discountedPrice;
  if (
    templateContext.discountsEnabled &&
    templateContext.discountCode !== window.productData?.discount_codes?.discount_code
  ) {
    price = window.formattedString
      ? window.formattedString.replace(/(0|0\.00|0,00)/, product.old_price / product.amount)
      : formatCurrency(product.old_price / product.amount);
  } else {
    price = product.formatted_price ? product.formatted_price : formatCurrency(product.price);
  }
  if (
    (templateContext.discountsEnabled &&
      templateContext.discountCode == window.productData?.discount_codes?.discount_code) ||
    !templateContext.discountsEnabled
  ) {
    discountedPrice = product.formatted_old_price ? product.formatted_old_price : formatCurrency(product.old_price);
  }

  return (
    <div
      data-cy="product-container"
      onClick={() => {
        handleChange(index);
      }}
      id={`productCard-${index}`}
      className={
        active
          ? `productPackages__container bundles productPackage__container--visible`
          : `productPackages__container bundles productPackages__container--unchecked`
      }
    >
      <div className="productPacItem__topBlock">
        <ProductSelectorButton additionalClasses="bundles" />
        <span data-cy="product-amount" className="productPacItem__label__amount">
          {product.amount}x
        </span>
        &nbsp;–&nbsp;
        <span className="productPacItem__label">{product.display_name}</span>
        <div className="productPacItem__discount__box desktopHide" style={!showBadges ? { opacity: "0" } : {}}>
          <img src={DoubleTagIcon} /> {product.you_save_percentage}%
        </div>
      </div>
      <div className="separator"></div>
      <div className="productPacItem__firstBlock">
        <img
          className={`productPacItem__image ${outlineBorder ? "productPacItem__image--border" : ""}`}
          src={image}
          alt={product.image.alt}
        />
      </div>
      <div className="productPacItem__divider mobileHide"></div>
      <div className="productPacItem__discount__container mobileHide">
        <div className="productPacItem__discount__box" style={!showBadges ? { opacity: "0" } : {}}>
          <img src={DoubleTagIcon} /> {product.you_save_percentage}%
        </div>
      </div>
      <div className="productPacItem__divider tabletHide smallMobileHide"></div>
      <div className="productPacItem__priceBlock__container">
        {discountedPrice && (
          <div data-cy="product-price-old" className="productPacItem__priceBlock__oldPrice">
            {discountedPrice}
          </div>
        )}
        <div className="productPacItem__priceBlock__mainPriceBlock">
          {priceObject.symbolLeft && <sup>{priceObject.symbol}</sup>}
          <div data-cy="product-price" className="productPacItem__priceBlock__price">
            {priceObject.number}
          </div>

          <div className="productPacItem__priceBlock__centsBlock">
            <div data-cy="product-price-cents" className="productPacItem__priceBlock__cents">
              .{priceObject.cents}
            </div>

            <div className="productPacItem__priceBlock__each">
              {window.post_template.checkout_v4_products.tr_checkout_v4_products_eachLabel}
            </div>
          </div>
          {!priceObject.symbolLeft && (
            <div className="productPacItem__priceBlock" style={{ marginLeft: "2px" }}>
              <sup>{priceObject.symbol}</sup>
            </div>
          )}
        </div>
        {withLabel && <div className="productPacItem__priceBlock__labelTag">{product?.status?.toUpperCase()}</div>}
        {bestValue && (
          <div className="productPacItem__priceBlock__bestValueTag">{product?.tr_best_value_status?.toUpperCase()}</div>
        )}
      </div>
      {render && (
        <div
          className={`variants-container ${fadeIn ? "variants-container--show" : "variants-container--hide"}`}
          style={fadeIn ? { maxHeight: `${variantsRef?.current?.clientHeight}px` } : { maxHeight: "0px" }}
        >
          <div ref={variantsRef}>
            <section className="variant-container">
              <div className="variant-seperator"></div>
              <div className="variant-container__wrapper">
                <div className="bundle-label">{window.post_template?.checkout_v4_products?.tr_bundle_block_label}</div>
                <div className="bundle-products">{decode(product?.tr_bundle_products)}</div>
              </div>
            </section>
          </div>
        </div>
      )}
    </div>
  );
});

export default ProductBundleItem;
